import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback, createRef } from 'react';
import keycode from 'keycode';

var _excluded = ["defaultChecked", "disabled", "name", "onChange", "options", "value"];

var getValue = function getValue(value) {
  return value === undefined || value === null ? '' : String(value);
};

var findByValue = function findByValue(data, value) {
  return data.find(function (option) {
    return getValue(option.value) === getValue(value);
  });
};
var useRadioGroup = function useRadioGroup(_ref) {
  var isGroupDisabled = _ref.disabled,
      name = _ref.name,
      handleChange = _ref.onChange,
      _ref$options = _ref.options,
      data = _ref$options === void 0 ? [] : _ref$options,
      externaValue = _ref.value,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var container = _extends({
    role: 'radiogroup'
  }, otherProps);

  var onKeyDown = useCallback(function (event) {
    if (event.keyCode === keycode('enter') || event.keyCode === keycode('space')) {
      event.preventDefault();
      event.currentTarget.click();
    }
  }, []);
  var options = data.map(function (option, index) {
    var disabled = option.disabled,
        text = option.text,
        value = option.value;
    var inputRef = createRef();
    var checked = String(externaValue) === String(value);
    var tabIndex = -1;

    if (!disabled && (checked || externaValue === undefined && index === 0)) {
      tabIndex = 0;
    }

    return {
      text: text,
      container: {
        onClick: function onClick(event) {
          event.preventDefault();

          if (disabled || event.target === inputRef.current) {
            return;
          }

          if (inputRef.current) {
            inputRef.current.click();

            if (event.target.tabIndex < 0) {
              inputRef.current.focus();
            }
          }
        },
        onKeyDown: onKeyDown
      },
      input: {
        'aria-checked': checked,
        checked: checked,
        disabled: isGroupDisabled || disabled,
        name: name,
        onChange: function onChange(event) {
          event.persist();

          if (handleChange) {
            event.detail = findByValue(data, event.target.value);
            handleChange(event);
          }
        },
        ref: inputRef,
        role: 'radio',
        tabIndex: tabIndex,
        type: 'radio',
        value: value
      }
    };
  });
  return {
    container: container,
    options: options
  };
};

export { findByValue, useRadioGroup };
//# sourceMappingURL=useRadioGroup.js.map
